module.exports = __webpack_public_path__ + "67509ed69e7df0a2b006968ad5f7d496.svg";